import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import RadioButtonsDps from "./radioButtonsDps";
import BoxCounterFull from "./boxCounterFull";
import RadioButtonsMoneyHooks from "./RadioButtonsMoneyHooks";
import { DualRing } from "react-loading-io";
import alert from "../Resources/img/icon-alert-yellow.png";
import { comboValidator, validatorFieldPrimaAhorro } from "../Utils/validators";
import ErrorCustom from "./errorCustom";
import { useSelector } from "react-redux";
import Switch from "react-switch";
import { originLeads } from "../Utils/constants";
import moment from "moment";
import DetailsTab from "./detailsTab";
import TitleQuoteForm from "./titleQuoteForm";
import BoxNumber from "./boxNumber";
import AlertMessage from "./alertMessage";

const HookFormVas = ({
  submitValues,
  listPercentCC,
  dataState,
  onClick,
  investmentProfile,
  isError,
  setState,
}) => {
  const {
    handleSubmit,
    register,
    errors,
    setValue,
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [penalty, setPenaty] = useState(false);
  const [checkedPenalty, setCheckedPenalty] = useState(false);
  const [verifyMoney, setVerifyMoney] = useState("USD");
  const [verifyYears, setVerifyYears] = useState(0);
  const [tempValue, setTempValue] = useState(0);
  const [dps, setDps] = useState(false);
  const channel = useSelector((state) => state.login.channel);
  const originLeadList = originLeads;
  const [defaultValue, setDefaultValue] = useState(5000);

  const onSubmit = (values) => {
    let yearClient = moment(values.birthday, "DD/MM/YYYY").format("YYYY-MM-DD");
    let dateNow = moment().format("YYYY-MM-DD");
    let validateAgePresentDps =
      parseInt(dateNow.split("-")[0]) - parseInt(yearClient.split("-")[0]) >=
      70;
    if (validateAgePresentDps) {
      values.dps = true;
      setChecked(false);
    }

    const data = {
      ...values,
      channel,
      isAditionalsTopping: validateAgePresentDps ? true : checked,
      penalty: checkedPenalty,
    };

    submitValues(data);
  };

  const handleSwitchPenalty = () =>
    setCheckedPenalty((prevChecked) => !prevChecked);

  const handleSwitch = () => setChecked((prevChecked) => !prevChecked);
  useEffect(() => {}, [verifyMoney]);

  useEffect(() => {
    const initValue = verifyMoney === "USD" ? 5000 : 15000;
    setDefaultValue(initValue);
  }, [verifyMoney]);

  return (
    <>
      <div className="vasForm">
        <TitleQuoteForm
          title="Ahorro Seguro"
          subtitle="Obtén la cotización en unos minutos"
        />
        <DetailsTab
          dataState={dataState}
          list={true}
          onClick={onClick}
          customerProfile={investmentProfile}
        />
        <form onSubmit={handleSubmit(onSubmit)} className="vasForm__form">
          <div className="vasForm__form__input-container">
            <label>Capital</label>
            <RadioButtonsMoneyHooks
              register={register}
              name="money_vas"
              setVerifyMoney={setVerifyMoney}
              enableMoneyPEN={true}
              setState={setState}
            />
            <BoxNumber
              setValue={setValue}
              register={register}
              initCounter={defaultValue}
              nameVal="capital"
              verifyMoney={verifyMoney}
              incrementValue={1000}
              validatorInput={validatorFieldPrimaAhorro}
            />
            <ErrorCustom errors={errors} name="capital" />
          </div>

          <div className="vasForm__form__input-container">
            <BoxCounterFull
              register={register}
              setValue={setValue}
              initCounter={2}
              title="Tiempo de protección"
              nameVal="years"
              incrementValue={1}
              setVerifyYears={setVerifyYears}
              maxYear={5}
            />
          </div>

          <div className="vasForm__form__input-container-select">
            <label>Origen</label>
            <select
              id="originLead"
              name="originLead"
              ref={register({ validate: comboValidator })}
            >
              <option value="">Seleccione</option>
              {originLeadList.map((item, index) => (
                <option value={item.value} key={index}>
                  {item.description}
                </option>
              ))}
            </select>
            <ErrorCustom errors={errors} name="originLead" />
          </div>

          <div className="vasForm__form__input-container-select">
            <label>% Cesión de Comisión (0-100)</label>
            <select
              id="percentCommission"
              name="percentCommission"
              ref={register({ validate: comboValidator })}
            >
              {listPercentCC.length &&
                listPercentCC.map((val, idx) => (
                  <option key={idx} value={val}>
                    {val}%
                  </option>
                ))}
            </select>
            <ErrorCustom errors={errors} name="percentCommission" />
          </div>

          <div
            className="vasForm__form__input-container-dps-counter"
            style={{ marginBottom: "0rem" }}
          >
            <div className="vasForm__form__input-container-dps-counter__portafolio">
              <label>¿El asegurado cuenta con DPS afirmativa?</label>
              <div className="vasForm__form__input-container-dps-counter__portafolio__container">
                <RadioButtonsDps
                  register={register}
                  setDps={setDps}
                  setChecked={setChecked}
                  name="dps"
                  id="vas"
                />
              </div>
            </div>
          </div>
          {!dps && (
            <div
              className="vasForm__form__input-container-select"
              style={{ marginTop: "0rem" }}
            >
              <label>¿Sin Coberturas adicionales?</label>
              <div>
                <Switch
                  onChange={handleSwitch}
                  checked={checked}
                  onColor="#92d66f"
                />
              </div>
            </div>
          )}
          {!penalty && (
            <div className="vasForm__form__input-container-select">
              <label>Penalidad</label>
              <div>
                <Switch
                  onChange={handleSwitchPenalty}
                  checked={checkedPenalty}
                  onColor="#92d66f"
                />
              </div>
            </div>
          )}
          {isError && (
            <div className="vasForm__form__btn-container">
              <AlertMessage
                background="#FFEFD8"
                icono={alert}
                mensaje="Llegaste al límite máximo de cotizaciones, limpia la tabla de cotizaciones para crear una nueva cotización."
              />
            </div>
          )}
          <div className="vasForm__form__btnew-group">
            <button id="button_quote_vas" type="submit" className="btn btnew">
              Cotizar
            </button>
          </div>
        </form>
        {loading && (
          <div className="loading-field">
            <DualRing size={50} />
          </div>
        )}
      </div>
    </>
  );
};

export default HookFormVas;
